import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Button } from '@chakra-ui/react';

import * as actions from '../../../redux/actions/index';
import LogTypes from '../../../config/LogTypes';

export default function CreateWorkStation() {
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const me = useSelector((state) => state.me);
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(
      actions.logCreate(
        me.employee_id,
        LogTypes.SYSTEM_EDIT,
        `สร้างสถานีงานใหม่ ${data.workstation_name}  `,
      ),
    );

    dispatch(actions.workstationPost(data)).then(() => {
      console.log('เพิ่มสถานีงานสำเร็จ');

      dispatch(actions.workstationAll());
      history.push('/hrms/workstation');
    });
  };

  return (
    <div>
      <h2 className="text-gray-800 text-xl font-semibold py-1">
        เพิ่มสถานีงาน
      </h2>
      <div className="flex justify-between py-6">
        <Link to="/hrms/workstation/">
          <Button variant="outline">กลับ</Button>
        </Link>
      </div>
      <div className="p-4">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-6/12 px-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="relative w-full mb-3">
                <p
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  ชื่อสถานีงาน
                </p>
                <input
                  name="workstation_name"
                  type="text"
                  required
                  ref={register}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="ชื่อสถานีงาน"
                />
              </div>
              <div className="relative w-full mb-3">
                <p
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  สถานที่ตั้ง
                </p>
                <input
                  name="workstation_location"
                  type="text"
                  required
                  ref={register}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="สถานที่ตั้งของสถานีงงาน"
                />
              </div>

              <div className="relative w-full mb-3">
                <div className="text-center mt-6">
                  <Button isFullWidth colorScheme="blue" type="submit">
                    เพิ่ม
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
